<app-in-app-page>
  <app-header title="Search"></app-header>

  <main class="faxes">
    <div class="paper faxes-filters-bar">
      <div class="faxes-filters-bar__group">
        <app-calendar
          [timezone]="timezone"
          placeholder="From date"
          [class]="'select_m'"
          (dateChanged)="setFaxesDateSearchParam('after', $event)"
        ></app-calendar>

        <app-calendar
          [timezone]="timezone"
          placeholder="To date"
          [class]="'select_m'"
          (dateChanged)="setFaxesDateSearchParam('before', $event)"
        ></app-calendar>
      </div>

      <div class="faxes-filters-bar__group">
        <app-select
          [items]="FAX_STATUSES"
          placeholder="Status"
          [customClass]="'select_m'"
          (selectChange)="setFaxesStatusSearchParam($event)"
        ></app-select>

        <app-select
          [items]="FAX_DIRECTIONS"
          placeholder="Direction"
          [customClass]="'select_m'"
          (selectChange)="setFaxesDirectionSearchParam($event)"
        ></app-select>
      </div>

      <!-- <div class="faxes__folder-select-wrapper">
        <app-select
          (selectChange)="changeFolderFilter($event)"
          [items]="foldersNames"
          placeholder="Folder"
          [customClass]="'select_m'"
        ></app-select>
      </div> -->
    </div>

    <div class="faxes-table">
      <div class="faxes-table__head">
        <h4>Message</h4>
        <h4>Fax Number</h4>
        <h4>From Number</h4>
        <h4>Fax Date</h4>
        <h4>Pages</h4>
        <h4>Status</h4>
        <h4>Type</h4>
        <h4>Folder</h4>
        <h4>Actions</h4>
      </div>

      <div *ngIf="isFaxesLoading; else faxesTableBody" class="faxes-table__body">
        <div class="faxes-table__row" *ngFor="let row of skeletonRows">
          <span class="skeleton faxes-table__skeleton-cell"></span>
          <span class="skeleton faxes-table__skeleton-cell"></span>
          <span class="skeleton faxes-table__skeleton-cell"></span>
          <span class="skeleton faxes-table__skeleton-cell"></span>
          <span class="skeleton faxes-table__skeleton-cell"></span>
          <span class="skeleton faxes-table__status-icon"></span>
          <span class="skeleton faxes-table__skeleton-cell"></span>
          <span class="skeleton faxes-table__skeleton-cell"></span>
          <span class="skeleton faxes-table__skeleton-cell"></span>
        </div>
      </div>

      <ng-template #faxesTableBody>
        <div class="faxes-table__body">
          <div *ngFor="let fax of faxes" (click)="navigateToFax($event, fax.id)" class="faxes-table__row">
            <p>{{ fax.id }}</p>

            <p>{{ getFaxNumber(fax) }}</p>

            <p>{{ fax.fromNumber }}</p>

            <p class="faxes-table__date-cell">
              <span *ngFor="let datePart of splitISODate(fax.faxDate)">
                {{ datePart }}
              </span>
            </p>

            <p>{{ fax.pages }}</p>

            <div>
              <img
                [src]="getFaxStatusIconSrc(fax.status)"
                [alt]="fax.status"
                class="faxes-table__status-icon"
              />
            </div>

            <p>{{ fax.direction === 0 ? "In" : "Out" }}</p>

            <p [title]="getFolderName(fax.folderId)">{{ getFolderName(fax.folderId) | truncate: 10 }}</p>

            <div class="faxes-table__actions-cell" (click)="$event.preventDefault()">
              <button class="icon-btn" (click)="downloadFaxFile(fax.id)">
                <img src="assets/icons/download-orange.svg" alt="Download fax PDF" />
              </button>

              <button class="icon-btn" (click)="openFaxFile(fax.id)">
                <img src="assets/icons/print.svg" alt="Print fax PDF" />
              </button>

              <button class="icon-btn" (click)="openResendModal(fax)">
                <img src="assets/icons/mail-orange.svg" alt="Resend fax" />
              </button>

              <button class="icon-btn" (click)="openDeleteConfirmationPopup(fax)">
                <img src="assets/icons/delete-orange.svg" alt="Delete fax" />
              </button>
            </div>
          </div>
        </div>
      </ng-template>
    </div>

    <div class="paper faxes-footer">
      <div class="faxes-pagination">
        <p class="faxes-pagination__items-count">
          {{ startFaxNumber }}-{{ endFaxNumber }} of
          <span>{{ totalFaxesCount }}</span>
        </p>

        <div class="faxes-pagination__controls">
          <button class="icon-btn" [disabled]="isPrevPageDisabled" (click)="prevFaxesPage()">
            <img src="assets/icons/pagination-arrow-left.svg" alt="Prev faxes page" />
          </button>

          <button class="icon-btn" [disabled]="isNextPageDisabled" (click)="nextFaxesPage()">
            <img src="assets/icons/pagination-arrow-left.svg" alt="Next faxes page" class="next-page-icon" />
          </button>
        </div>
      </div>

      <div class="separator"></div>

      <div class="faxes-timezone-select">
        <span class="faxes-timezone-select__label">Time Zone</span>
        <app-select
          [items]="timezones"
          [activeItem]="timezone"
          placeholder="Eastern"
          customClass="select_top"
          (selectChange)="setTimezone($event)"
        ></app-select>
      </div>
    </div>
  </main>
</app-in-app-page>

<app-delete-fax-modal (submit)="deleteFax()"></app-delete-fax-modal>

<app-resend-fax-modal [fax]="faxToResend" [initialTab]="'Email'" (submit)="getFaxes()"></app-resend-fax-modal>

<app-error-modal [message]="fileErrorMessage"></app-error-modal>
